import { ApiSliceParams } from "../interfaces";
import { makeCalendar } from "./calendar";
import { makeCode } from "./code";
import { makeExternal } from "./external";
import { makeGroup } from "./group";
import { makePreliminary } from "./preliminary";
import { makeReport } from "./report";
import { makeTrack } from "./track";

export const MAX_REPORT_COMMENT_LENGTH = 1000;

export const makeTime = (params: ApiSliceParams) => {
    const calendar = makeCalendar(params);
    const external = makeExternal(params);
    const group = makeGroup(params);
    const report = makeReport(params);
    const track = makeTrack(params);
    const preliminary = makePreliminary(params);
    const code = makeCode(params);

    return {
        calendar,
        external,
        group,
        report,
        track,
        preliminary,
        code,
    };
};
